import { auth } from "../firebase";

const API = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function authHeader() {
  const u = auth.currentUser;
  if (!u) return {};
  const token = await u.getIdToken(true);
  return { Authorization: `Bearer ${token}` };
}

async function fetchJson(url, opts = {}) {
  const res = await fetch(url, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(opts.headers || {}),
      ...(await authHeader()),
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || data?.message || `HTTP ${res.status}`);
  return data;
}

export async function apiGetMyProfile() {
  return fetchJson(`${API}/me/profile`, { method: "GET" });
}

export async function apiUpdateMyDelivery({ phone, city, address }) {
  return fetchJson(`${API}/me/delivery`, {
    method: "PUT",
    body: JSON.stringify({ phone, city, address }),
  });
}